const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
  
      width: "597px",
      height: "262px",
      borderRadius: "50px",
      background: "#333333",
  
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    overlay: {
      zIndex: 3,
    },
};

export {customStyles}